import React from 'react';
import iconGlobe from "../assets/Footer_Icon_Globe.png";
import iconInstagram from "../assets/Footer_Icon_Instagram.png";
import iconLinkedin from "../assets/Footer_Icon_Linkedin.png";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bt-footer">
      <div className="bt-footer-container">
        <p className="bt-footer-text">
          © 2026 Big Tiny Group. All rights reserved.
        </p>

        <div className="bt-footer-socials">
          <a href="https://tinyaway.com/stays-to-reconnect" aria-label="Website" className="bt-social">
            <img src={iconGlobe} alt="Big Tiny iconGlobe" className="icon-footer" />
          </a>

          <a href="https://www.instagram.com/tiny.away/" aria-label="Instagram" className="bt-social">
            <img src={iconInstagram} alt="Big Tiny iconInstagram" className="icon-footer" />
          </a>

          <a href="https://www.linkedin.com/company/big-tiny-pte-ltd" aria-label="LinkedIn" className="bt-social">
            <img src={iconLinkedin} alt="Big Tiny iconLinkedin" className="icon-footer" />
          </a>

        </div>
      </div>
    </footer>

  );
}
